// extracted by mini-css-extract-plugin
export default {"homeIntroCard":"HomeIntroCard_homeIntroCard__XV8BA","homeIntroCard-icon":"HomeIntroCard_homeIntroCard-icon__o0rKG"};